<template>
  <!-- 首页 -->
  <div class="pageapp">
    <a-card class="card">
      <a-tabs default-active-key="1" @change="callback" style="margin-top: 20px">
        <a-tab-pane key="1" tab="待审批"><ApprovalPending /></a-tab-pane>
        <a-tab-pane key="2" tab="审批通过" force-render><ApprovalPass /></a-tab-pane>
        <a-tab-pane key="3" tab="审批不通过"><ApprovalFail /> </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import ApprovalFail from './ApprovalFail.vue'
import ApprovalPass from './ApprovalPass.vue'
import ApprovalPending from './ApprovalPending.vue'
export default {
  components: {
    ApprovalPass,
    ApprovalFail,
    ApprovalPending,
  },
  methods: {
    callback(key) {
      console.log(key)
    },
  },
}
</script>

<style lang='less' scoped>
/deep/.ant-card-body {
  padding: 0;
}
.pageapp {
  width: 100%;
  height: 100%;
}
/deep/.ant-table-bordered.ant-table-empty .ant-table-placeholder {
  width: 97%;
  margin-left: 15px;
}
/deep/.ant-table-empty .ant-table-body {
  margin-left: 15px;
  width: 97%;
}
/deep/.ant-tabs-nav-scroll{
    width: 95%;
  margin-left: 32px;

}
/deep/.ant-table-body {
  width: 95%;
  margin-left: 32px;
}
.card {
  width: 100%;
  height: 100%;
  // margin: 0 auto;
  margin-bottom: 20px;
}
</style>